export default "__VITE_ASSET__PvX2NGB7__"